<div class="login-root" [class.login-root--overlay]="overlay" [class.login-root--page]="!overlay">
  @if (overlay) {
    <button type="button" class="login-close" (click)="close()" aria-label="Close sign in">×</button>
  }

  <div class="login-panel">
    <div class="login-brand">
      <img class="login-logo" src="/assets/tenants/pda/logo.png" width="52" height="52" alt="PDA logo" />
      <div>
        <p class="login-kicker">PDA Digital Platform</p>
        <h1>Sign in</h1>
        <p>One portal for PDA document and building compliance workspaces</p>
      </div>
    </div>

    <form class="login-form" (ngSubmit)="signIn()">
      <label>
        User ID
        <input
          [(ngModel)]="form.userId"
          name="userId"
          autocomplete="username"
          required
          [disabled]="busy()"
        />
      </label>

      <label>
        Password
        <input
          [(ngModel)]="form.password"
          name="password"
          type="password"
          autocomplete="current-password"
          required
          [disabled]="busy()"
        />
      </label>

      <label>
        Authority
        <select [(ngModel)]="form.authorityId" name="authorityId" [disabled]="busy()">
          <option value="PDA">Prayagraj (PDA)</option>
          <option value="LDA">Lucknow (LDA)</option>
        </select>
      </label>

      @if (error()) {
        <p class="error">{{ error() }}</p>
      }
      @if (info()) {
        <p class="info">{{ info() }}</p>
      }

      <button type="submit" class="login-btn" [disabled]="busy()">
        {{ busy() ? 'Signing in…' : 'Sign in' }}
      </button>
    </form>

    @if (!overlay) {
      <p class="hint back">
        <a href="/">Back to home</a>
      </p>
    }
  </div>
</div>
